var map = {
	"./goods_1000.png": 90712,
	"./goods_10000.png": 97162,
	"./goods_300.png": 40832,
	"./goods_3000.png": 77058,
	"./goods_5000.png": 20084,
	"./goods_alarm.png": 7020
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49142;